import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserService } from '../services/user_service';
import { StreamService } from '../services/stream_service';
import { forkJoin, switchMap, catchError, of } from 'rxjs';

export const UserStreamsRedirectGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const streamService = inject(StreamService);
  const router = inject(Router);

  return forkJoin([
    userService.listCommunities(),
    userService.getProfile()
  ]).pipe(
    switchMap(([communityMember, user]) => {
      if (!user || user.id === '') {
        return userService.login().then(() => false);
      }

      return Promise.all([
        streamService.getUserStreams(true),
        streamService.getUserTeamStreams()
      ]).then((results: any) => {
        const userStreams = results[0];
        const userTeamStreams = results[1].channels ? results[1].channels : [];

        const hasContent = userStreams.length > 0 || userTeamStreams.length > 0 || communityMember.length > 0;

        if (hasContent) {
          return true;
        } else {
          return router.createUrlTree(['/new-note-guide']);
        }
      }).catch(() => {
        return false;
      });
    }),
    catchError(() => {
        return of(false);
    })
  );
};